import { getFirebaseAuth } from "@/lib/firebase/auth-instance";

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

async function resolveIdToken(forceRefresh: boolean): Promise<void> {
  const user = getFirebaseAuth().currentUser;
  if (!user || user.isAnonymous) {
    return;
  }
  try {
    await user.getIdToken(forceRefresh);
  } catch (firstError) {
    if (forceRefresh) {
      throw firstError;
    }
    await user.getIdToken(true);
  }
}

/** Wait until Firebase Auth has restored the session and issued a token. */
export async function waitForAuthToken(maxMs = 12000): Promise<void> {
  const auth = getFirebaseAuth();
  await auth.authStateReady();

  const started = Date.now();
  while (Date.now() - started < maxMs) {
    const user = auth.currentUser;
    if (user && !user.isAnonymous) {
      await resolveIdToken(false);
      return;
    }
    await sleep(120);
  }
  throw new Error("auth_token_timeout");
}
